import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

const DescContainer = styled.div`
  width: 100%;
  height: 323px;
  background-color: #0e1e36;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 40px;
  color: white;
  font-weight: 600;
`;

const TipsBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${flexGap('20px')}
  max-width: 572px;
`;

const Tips = styled.p`
  font-size: 16px;
  color: #fff;
  font-weight: 400;
`;

const DescContent = styled.div`
  width: var(--home-section-width);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const Desc = () => {
  return (
    <DescContainer>
      <DescContent>
        <Title>
          More than a flight,
          <br /> a commitment
        </Title>
        <TipsBox>
          <Tips>
            With 10+ years of industry expertise, we’ve built a reputation for
            <br /> coordinating seamless, reliable, and thoughtfully arranged private
            <br /> flights tailored to every journey.
          </Tips>
          <Tips>
            Airacer ensures every detail is executed flawlessly, from pre-flight logistics
            <br /> to post-landing coordination. Every trip is meticulously planned and
            <br /> prioritizes your safety, schedule, and personal preferences.
          </Tips>
        </TipsBox>
      </DescContent>
    </DescContainer>
  );
};

export default Desc;
